import React from 'react';
import styles from "./Modal.module.css";
import { Stack,StackItem,TextField,FontIcon,Text,DefaultButton,IButtonStyles, ICommandBarStyles  } from '@fluentui/react';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import supersub from 'remark-supersub'
import { useState } from 'react';
import Send from "../../assets/Send.svg";
import { IconButton } from '@fluentui/react';
import { Dislikeoptions } from './Utils/Modalutils';
import { useContext } from 'react';
import { AppStateContext } from '../state/AppProvider';


function ModalLike() {
  const [Comentario, setComentario] = useState<string>("");
  const OnComentarioChange = (_ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    setComentario(newValue || "");
};
const appStateContext = useContext(AppStateContext)

const ModalButtonStyles: ICommandBarStyles & IButtonStyles = {
  root: {
      width: '150px',
      height: '40px',
      border: `1px solid #D1D1D1`,
      borderRadius:'5px'
    },
    rootHovered: {
      border: `1px solid #D1D1D1`,
    },
    rootPressed: {
      border: `1px solid #D1D1D1`,
    }
};
  const handlesubmit= () =>{
    appStateContext?.dispatch({ type: 'SET_COMMENT', payload: Comentario });
    appStateContext?.dispatch({ type: 'TOGGLE_LIKE_MODAL', payload: false });
  };

  const handleclose= () =>{
    appStateContext?.dispatch({ type: 'SET_COMMENT', payload: "" });
    appStateContext?.dispatch({ type: 'TOGGLE_LIKE_MODAL', payload: false });
  };
  return (
    <>
     <div className={styles.ModalContainer}>
     <Stack className={styles.questionInputContainer}>
        <div style={{height:15}}></div>
        <Stack horizontal  className={styles.ModalHeaderContainer} horizontalAlign='baseline'>
          <Stack grow={1}  style={{}} horizontalAlign='center'>
              <Stack horizontal className={styles.HeaderStack} horizontalAlign='center' >
                 <FontIcon className={styles.ModalLikeIcon}
                               iconName={'like'}
                                />
                  <div style={{width:10}} ></div>
                  <Text className={styles.HeaderPanelContent}>Proporcionar comentarios adicionales</Text>
                </Stack>
            </Stack>
            
            <Stack.Item>
                <IconButton iconProps={{ iconName: 'Cancel'}} aria-label="Close comment modal" onClick={handleclose}/>
            </Stack.Item>
            <div style={{width:30}}></div>
        </Stack>
        <div style={{height:20}}></div>
        <div className={styles.BorderModal} />
        <div style={{height:20}}></div>
        <Stack horizontal  className={styles.InputContainer} horizontalAlign='center'>
          <Stack horizontal className={styles.TextfieldInput} grow={0.95} horizontalAlign='center'>
              
                <TextField
                    className={styles.questionInputTextArea}
                    placeholder={"¿Qué te gusta de la respuesta?"}
                    multiline
                    resizable={false}
                    borderless
                    value={Comentario}
                    onChange={OnComentarioChange}
                    
                    // onKeyDown={onEnterPress}
                />
                
            </Stack>
          </Stack>
          <div style={{height:35}}></div>
          <Stack horizontal  className={styles.SubmitButtonContainer} horizontalAlign='end'>
          <Stack grow={1}  style={{}} horizontalAlign='end'>
                <DefaultButton
                  text={"Enviar"}
                  onClick={handlesubmit}
                  styles={ModalButtonStyles}
              />
            </Stack>
  
            <div style={{width:30}}></div>
          </Stack>
          <div style={{height:10}}></div>
        </Stack>
    </div>
    </>
  );
}

export function ModalDisLike() {
  const [Comentario, setComentario] = useState<string>("");
  const OnComentarioChange = (_ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    setComentario(newValue || "");
};
  
  const [checkedState, setCheckedState] = useState(
    new Array(Dislikeoptions.length).fill(false)
  );

  const handlechangecheckbox = (position: number) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );

    setCheckedState(updatedCheckedState);

  };
  const appStateContext = useContext(AppStateContext)
  const handlesubmit = () =>{
    appStateContext?.dispatch({ type: 'SET_COMMENT', payload: Comentario });
    appStateContext?.dispatch({ type: 'SET_CHECKBOXES', payload: checkedState });
    appStateContext?.dispatch({ type: 'SET_DISIKE_MODAL', payload: false });
  }

  const handleclose = () => {
    appStateContext?.dispatch({ type: 'SET_COMMENT', payload: "" });
    appStateContext?.dispatch({ type: 'SET_CHECKBOXES', payload: [false,false,false] });
    appStateContext?.dispatch({ type: 'SET_DISIKE_MODAL', payload: false });

  }

const ModalButtonStyles: ICommandBarStyles & IButtonStyles = {
  root: {
      width: '150px',
      height: '40px',
      border: `1px solid #D1D1D1`,
      borderRadius:'5px'
    },
    rootHovered: {
      border: `1px solid #D1D1D1`,
    },
    rootPressed: {
      border: `1px solid #D1D1D1`,
    }
};

  return (
    <>
     <div className={styles.ModalContainer}>
     <Stack className={styles.DislikeInputContainer}>
        <div style={{height:15}}></div>
        <Stack horizontal  className={styles.ModalHeaderContainer} horizontalAlign='baseline'>
          <Stack grow={1}  style={{}} horizontalAlign='center'>
              <Stack horizontal className={styles.HeaderStack} horizontalAlign='center' >
                 <FontIcon className={styles.ModalDislikeIcon}
                               iconName={'dislike'}
                                />
                  <div style={{width:10}} ></div>
                  <Text className={styles.HeaderPanelContent}>Proporcionar comentarios adicionales</Text>
                </Stack>
            </Stack>
            
            <Stack.Item>
                <IconButton iconProps={{ iconName: 'Cancel'}} aria-label="Close comment modal" onClick={handleclose}/>
            </Stack.Item>
            <div style={{width:30}}></div>
        </Stack>
        <div style={{height:20}}></div>
        <div className={styles.BorderModal} />
        <div style={{height:20}}></div>
        <Stack horizontal  className={styles.InputContainer} horizontalAlign='center'>
          <Stack horizontal className={styles.TextfieldInput} grow={0.95} horizontalAlign='center'>
              
                <TextField
                    className={styles.questionInputTextArea}
                    placeholder={"¿Cuál fue el problema con la respuesta? ¿Cómo podría mejorarse?"}
                    multiline
                    resizable={false}
                    borderless
                    value={Comentario}
                    onChange={OnComentarioChange}
                    
                    // onKeyDown={onEnterPress}
                />
                
            </Stack>
          </Stack>
          <div style={{height:20}}></div>
          {Dislikeoptions.map(({ name, Value }, index) => {
          return (
            <>
            <Stack horizontal  className={styles.ModalHeaderContainer} horizontalAlign='baseline'>
                <Stack grow={1}  style={{}} horizontalAlign='center'>
                    <Stack horizontal className={styles.HeaderStack} horizontalAlign='center' >
                      <input
                          type="checkbox"
                          id={`custom-checkbox-${index}`}
                          name={name}
                          value={name}
                          checked={checkedState[index]}
                          onChange={() => handlechangecheckbox(index)}
                          style={{width:20,height:20}}
                        />
                        <div style={{width:10}} ></div>
                        <Text className={styles.OptionsText}>{Value}</Text>
                      </Stack>
                  </Stack>
                  <div style={{width:30}}></div>
              </Stack>
            </>
            
          );
        })}
          
          <div style={{height:10}}></div>
          <Stack horizontal  className={styles.SubmitButtonContainer} horizontalAlign='end'>
          <Stack grow={1}  style={{}} horizontalAlign='end'>
                <DefaultButton
                  text={"Enviar"}
                  onClick={handlesubmit}
                  styles={ModalButtonStyles}
              />
            </Stack>
  
            <div style={{width:30}}></div>
          </Stack>
          <div style={{height:40}}></div>
        </Stack>
    </div>
    </>
  );
}

export default ModalLike;